import React from 'react';
const benefits = [{
  icon: '📚',
  title: '6 Jahres-Bände',
  desc: 'Von den Wurzeln bis zum kreativen Vinyasa. Ein Jahr Evolution.'
}, {
  icon: '🩺',
  title: 'Therapeutisches Yoga',
  desc: 'Protokolle für Rückenschmerzen, Angst, Menopause und Ü60.'
}, {
  icon: '🌸',
  title: 'Philosophie & Themen',
  desc: '52 fertige Intentionen, um jeder Stunde eine Seele zu geben.'
}, {
  icon: '🌊',
  title: 'Die Kunst des Flows',
  desc: 'Handbuch für elegante Übergänge ohne Unterbrechungen.'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-14" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-4">
            🎁 Was enthält das Yoga-Bereit Kit?
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-5">
            Alles, was Sie brauchen, in einem einzigen digitalen Paket. Sechs
            technische Säulen, die Ihr Studio zum Strahlen bringen.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8" data-id="element-6">
          {benefits.map((benefit, i) => <div key={i} className="bg-bg-alt p-8 rounded-3xl border border-border-light shadow-xl flex flex-col gap-4 hover:-translate-y-1 hover:border-primary/40 transition-all duration-300 relative overflow-hidden group" data-id="element-7">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-8"></div>

              <div className="w-14 h-14 rounded-2xl bg-bg-dark border border-primary/20 flex items-center justify-center text-3xl mb-2 relative z-10 shadow-inner" data-id="element-9">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-bold text-text-main relative z-10" data-id="element-10">
                {benefit.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-lg relative z-10" data-id="element-11">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}